<template>
  <div class="estimate-page-wrapper m-left-page">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#0f172a"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <!-- Top Executive Header -->
    <v-card flat class="estimate-header-card pa-4 mb-4 rounded-lg">
      <v-layout wrap align-center justify-space-between>
        <v-flex xs12 sm7 md6 class="d-flex align-center flex-wrap">
          <div class="d-flex align-center mr-3">
            <v-icon color="#0f172a" class="mr-2" size="22">mdi-file-document-edit-outline</v-icon>
            <span class="estimate-title-tag">ESTIMATE</span>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              v-model="billPrefix"
              placeholder="Prefix"
              outlined
              dense
              hide-details
              class="estimate-prefix-field mr-2"
              color="#9a6b27"
            ></v-text-field>
            <div class="estimate-number-pill">
              <v-icon small color="#64748b" class="mr-1">mdi-pound</v-icon>
              <span>{{ estno }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm5 md6 class="d-flex align-center justify-end mt-2 mt-sm-0">
          <div class="estimate-date-badge" v-if="date">
            <v-icon small color="#64748b" class="mr-1">mdi-calendar-range</v-icon>
            <span>{{ date }}</span>
          </div>
        </v-flex>
      </v-layout>

      <v-divider class="header-divider"></v-divider>

      <div class="header-controls-row">
        <div class="header-control-col">
          <label class="erp-field-label">Transaction Type</label>
          <v-select
            v-model="billMode"
            :items="billModeOptions"
            outlined
            dense
            hide-details
            color="#9a6b27"
            prepend-inner-icon="mdi-swap-horizontal"
            class="erp-field"
          ></v-select>
        </div>
        <div class="header-control-col">
          <label class="erp-field-label">Salesman</label>
          <v-select
            v-model="salesmenCode"
            :items="salesmanOptions"
            item-text="label"
            item-value="staffCode"
            outlined
            dense
            hide-details
            color="#9a6b27"
            prepend-inner-icon="mdi-account-tie-outline"
            class="erp-field"
          ></v-select>
        </div>
      </div>
    </v-card>

    <v-layout wrap>
      <v-flex xs12 pb-6 text-left>
        <!---------------------CUSTOMER DETAILS------------------------->
        <v-card flat class="estimate-card mb-4 rounded-lg">
          <div class="card-top-bar px-4 py-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon small color="#475569" class="mr-2">mdi-account-outline</v-icon>
              <span class="card-heading">Customer Details</span>
            </div>
            <v-btn
              small
              outlined
              color="#475569"
              class="rounded-lg text-capitalize erp-btn-secondary"
              @click="addcustomerdialogue = true"
            >
              <v-icon left small>mdi-account-plus</v-icon>
              Add Customer
            </v-btn>
          </div>
          <v-divider></v-divider>
          <div class="pa-4">
            <div class="customer-grid">
              <div class="customer-field-col">
                <label class="erp-field-label">Customer Name</label>
                <v-autocomplete
                  v-if="customerList"
                  color="#9a6b27"
                  @input="customerdetails()"
                  @update:search-input="searchCustomerByKeyword"
                  :items="customerList"
                  v-model="customerName"
                  placeholder="Search name or phone..."
                  item-text="customerName"
                  item-value="_id"
                  :filter="customerFilter"
                  outlined
                  hide-details
                  dense
                  class="erp-field"
                  prepend-inner-icon="mdi-magnify"
                ></v-autocomplete>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">Address</label>
                <v-text-field
                  type="text"
                  v-model="address"
                  outlined
                  disabled
                  placeholder="Address"
                  dense
                  hide-details
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">City</label>
                <v-text-field
                  type="text"
                  v-model="city"
                  outlined
                  disabled
                  placeholder="City"
                  dense
                  hide-details
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">Mobile Number</label>
                <v-text-field
                  type="number"
                  v-model="contact"
                  outlined
                  disabled
                  placeholder="Contact"
                  dense
                  hide-details="auto"
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-card>

        <!---------------------GOLD SCHEME------------------------->
        <v-card
          v-if="billMode === 'Sale' && redeemableSchemes.length > 0"
          flat
          class="estimate-card mb-4 rounded-lg"
        >
          <div class="card-top-bar px-4 py-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon small color="#475569" class="mr-2">mdi-piggy-bank-outline</v-icon>
              <span class="card-heading">Gold Scheme</span>
            </div>
            <span class="scheme-total-hint">
              ₹ {{ formatAmount(schemeAvailableTotal) }} available
            </span>
          </div>
          <v-divider></v-divider>
          <div class="pa-4">
            <div class="scheme-help mb-2">
              Select the matured scheme(s) this purchase should be paid from. Schemes are used in the order selected.
            </div>
            <div
              v-for="scheme in redeemableSchemes"
              :key="scheme._id"
              class="scheme-row d-flex align-center justify-space-between"
            >
              <v-checkbox
                :input-value="selectedSchemeIds.includes(scheme._id)"
                @change="toggleScheme(scheme._id)"
                color="#9a6b27"
                dense
                hide-details
                class="mt-0 pt-0"
              >
                <template v-slot:label>
                  <span class="scheme-no-pill mr-2">{{ scheme.schemeNumber || '—' }}</span>
                  <span class="scheme-name">{{ (scheme.goldSchemeId && scheme.goldSchemeId.goldSchemeName) || 'Gold Scheme' }}</span>
                  <span class="scheme-status ml-2">{{ scheme.schemeStatus }}</span>
                </template>
              </v-checkbox>
              <span class="scheme-avail">₹ {{ formatAmount(scheme.availableAmount) }}</span>
            </div>
          </div>
        </v-card>

        <!---------------------ITEM DETAILS------------------------->
        <ESaddItem
          v-if="billMode === 'Sale'"
          v-bind:title="estno"
          :datareload="datareload"
          :customerName="customerName"
          :contact="contact"
          @stepper="winStepper"
        />

        <!---------------------START PURCHASE / RETURN------------------------->
        <v-card
          v-if="billMode !== 'Sale' && !(billData && billData._id)"
          flat
          class="estimate-card mb-4 rounded-lg pa-4 text-center"
        >
          <div class="mb-3" style="color: #64748b; font-size: 13px;">
            Select a customer above, then start the {{ billMode }} entry below.
          </div>
          <v-btn
            dark
            class="erp-action-btn text-capitalize px-6"
            :disabled="!customerName || !contact"
            @click="startPurchaseOrReturn()"
          >
            <v-icon left small>mdi-arrow-right-circle-outline</v-icon>
            Start {{ billMode }}
          </v-btn>
        </v-card>

        <oldGold
          v-if="(billMode === 'Sale' && itempresent == true) || (billMode === 'Old Gold / Silver Purchase' && billData && billData._id)"
          v-bind:title2="billData"
          :standalone="billMode !== 'Sale'"
          @stepper="winStepper"
        />

        <returnGold
          v-if="(billMode === 'Sale' && itempresent == true) || (billMode === 'Sales Return' && billData && billData._id)"
          v-bind:title3="billData"
          @stepper="winStepper"
        />

        <div
          class="d-flex justify-end py-4"
          v-if="(billMode === 'Sale' && itempresent == true) || (billMode !== 'Sale' && billData && billData._id)"
        >
          <v-btn
            large
            dark
            class="generate-estimate-btn text-capitalize px-6 elevation-1"
            @click="validate()"
          >
            <v-icon left>mdi-file-document-check-outline</v-icon>
            {{ billMode === 'Sale' ? 'Generate Estimate' : 'Save ' + billMode }}
          </v-btn>
        </div>

        <!-- Add Customer Dialog -->
        <v-dialog width="640px" v-model="addcustomerdialogue">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card class="rounded-lg erp-modal-card">
              <div class="modal-top-bar px-6 py-4 d-flex align-center justify-space-between">
                <div>
                  <div class="modal-title">Add Customer</div>
                  <div class="modal-subtext">Enter customer profile details</div>
                </div>
                <v-btn icon small @click="addcustomerdialogue = false; resetForm()">
                  <v-icon color="#64748b">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <div class="px-6 py-4">
                <v-row dense>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Customer Name <span class="required-star">*</span></label>
                    <v-text-field
                      type="text"
                      placeholder="Enter Full Name"
                      v-model="newCustomer"
                      outlined
                      dense
                      :rules="[rules.required]"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Phone Number <span class="required-star">*</span></label>
                    <v-text-field
                      placeholder="10-digit number"
                      v-model="newContact"
                      outlined
                      :rules="phoneRules"
                      color="#9a6b27"
                      dense
                      type="number"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">PAN Number</label>
                    <v-text-field
                      type="text"
                      placeholder="e.g. ABCDE1234F"
                      v-model="newCustomerPAN"
                      outlined
                      dense
                      :rules="panRules"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Aadhaar Number</label>
                    <v-text-field
                      type="number"
                      placeholder="12-digit number"
                      v-model="newCustomerAadhar"
                      outlined
                      dense
                      :rules="aadhaarRules"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">City</label>
                    <v-text-field
                      color="#9a6b27"
                      type="text"
                      placeholder="Enter City"
                      v-model="newCity"
                      outlined
                      dense
                      hide-details
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Pin Code</label>
                    <v-text-field
                      color="#9a6b27"
                      type="number"
                      placeholder="6-digit PIN"
                      v-model="newpinNumber"
                      outlined
                      :rules="pinRules"
                      dense
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <label class="erp-field-label">Address</label>
                    <v-textarea
                      color="#9a6b27"
                      rows="2"
                      placeholder="Enter Address"
                      v-model="newAddress"
                      outlined
                      dense
                      hide-details
                      class="erp-field"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <v-divider></v-divider>
              <div class="px-6 py-3 d-flex justify-end align-center bg-modal-footer">
                <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="addcustomerdialogue = false; resetForm()">Cancel</v-btn>
                <v-btn dark class="erp-action-btn text-capitalize px-5" @click="AddCustomer()">
                  <v-icon left small>mdi-check</v-icon>
                  Save Customer
                </v-btn>
              </div>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- Quotation Preview Dialog -->
        <v-dialog
          style="z-index:3000;"
          v-model="preview"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card tile height="100%" class="preview-page-card m-left-page">
            <!-- Modal Header -->
            <div class="preview-header preview-head-bar px-6 py-4 d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon color="#0f172a" class="mr-2">mdi-file-document-outline</v-icon>
                <span class="preview-title">ESTIMATE / QUOTATION PREVIEW</span>
              </div>
              <v-btn icon @click="preview = false">
                <v-icon color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>

            <div class="pa-6 preview-scroll-area preview-body">
              <!-- Meta Cards (Customer & Estimate Info) -->
              <v-row dense class="mb-4">
                <v-col cols="12" md="6">
                  <v-card outlined class="pa-4 preview-info-card h-100">
                    <div class="preview-info-heading mb-3">
                      <v-icon small color="#64748b" class="mr-1">mdi-account-outline</v-icon>
                      Customer Details
                    </div>
                    <div class="preview-info-row" v-if="previewList2.customerName">
                      <span class="info-label">Customer Name:</span>
                      <span class="info-val font-weight-bold">{{ previewList2.customerName }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.mobileNumber">
                      <span class="info-label">Contact:</span>
                      <span class="info-val">{{ previewList2.mobileNumber }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.customerId && previewList2.customerId.address">
                      <span class="info-label">Address:</span>
                      <span class="info-val">{{ previewList2.customerId.address }}</span>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card outlined class="pa-4 preview-info-card h-100">
                    <div class="preview-info-heading mb-3">
                      <v-icon small color="#64748b" class="mr-1">mdi-information-outline</v-icon>
                      Estimate Information
                    </div>
                    <div class="preview-info-row" v-if="previewList2.billNo">
                      <span class="info-label">Estimate No:</span>
                      <span class="info-val font-weight-bold">{{ (previewList2.billPrefix || '') + previewList2.billNo }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.staffCode">
                      <span class="info-label">Salesman / Staff:</span>
                      <span class="info-val">{{ previewList2.staffCode }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.create_date">
                      <span class="info-label">Date:</span>
                      <span class="info-val">{{ formatDate(previewList2.create_date) }}</span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Bill Items Table -->
              <div v-if="previewList1 && previewList1.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-ring</v-icon>
                  Bill Items ({{ previewList1.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table m-stack-grid">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-left">HSN</th>
                          <th class="text-right">Qty</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Making Chg (₹)</th>
                          <th class="text-right">VA (%)</th>
                          <th class="text-right">Discount (₹)</th>
                          <th class="text-right">CGST (%)</th>
                          <th class="text-right">SGST (%)</th>
                          <th class="text-right">Total (₹)</th>
                          <th class="text-center" v-if="canEditPreview">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList1" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">
                            <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="HSN">
                            <span v-if="value.designId && value.designId.HSN">{{ value.designId.HSN.hsnCode }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="Qty" class="text-right">{{ value.quantity || '-' }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Making Chg (₹)" class="text-right">
                            {{ value.discountAmount ? (value.adjustedMakingCharge || 0).toFixed(2) : (value.makingCharge ? value.makingCharge.toFixed(2) : '0.00') }}
                          </td>
                          <td data-label="VA (%)" class="text-right">
                            {{ value.valueAddition ? value.valueAddition.toFixed(2) : '0.00' }}
                          </td>
                          <td data-label="Discount (₹)" class="text-right">{{ value.discountAmount ? value.discountAmount.toFixed(2) : '0.00' }}</td>
                          <td data-label="CGST (%)" class="text-right">{{ value.cgst ? value.cgst.toFixed(2) : '0.00' }}</td>
                          <td data-label="SGST (%)" class="text-right">{{ value.sgst ? value.sgst.toFixed(2) : '0.00' }}</td>
                          <td data-label="Total (₹)" class="text-right font-weight-bold">{{ value.amountWithGst ? value.amountWithGst.toFixed(2) : '0.00' }}</td>
                          <td data-label="Actions" class="text-center text-no-wrap" v-if="canEditPreview">
                            <v-btn icon x-small class="mr-1" color="#475569" title="Edit Item" @click="openPreviewEdit(value)">
                              <v-icon small>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon x-small color="#dc2626" title="Remove Item" @click="previewDeleteId = value._id; previewDeleteDialog = true">
                              <v-icon small>mdi-delete-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <div class="preview-edit-hint mt-2" v-if="canEditPreview">
                  <v-icon x-small color="#94a3b8" class="mr-1">mdi-information-outline</v-icon>
                  Customer wants a lower price? Edit an item to reduce quantity / weight, VA or add a discount, or remove it. The invoice uses these revised figures.
                </div>

                <!-- Price revision history -->
                <div class="revision-history mt-3" v-if="revisionHistory.length">
                  <div class="preview-table-title mb-2">
                    <v-icon small color="#475569" class="mr-1">mdi-history</v-icon>
                    Revision History ({{ revisionHistory.length }})
                  </div>
                  <v-simple-table dense class="revision-table m-stack-table">
                    <thead>
                      <tr>
                        <th class="text-left">#</th>
                        <th class="text-left">Date &amp; Time</th>
                        <th class="text-left">Edited By</th>
                        <th class="text-left">Action</th>
                        <th class="text-left">Item</th>
                        <th class="text-left">Changes</th>
                        <th class="text-right">Item Total (₹)</th>
                        <th class="text-right">Bill Total (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(r, i) in revisionHistory" :key="i">
                        <td data-label="#">{{ revisionHistory.length - i }}</td>
                        <td data-label="Date & Time" class="text-no-wrap">{{ formatRevisionDate(r.at) }}</td>
                        <td data-label="Edited By">{{ r.by }}</td>
                        <td data-label="Action"><span class="revision-tag" :class="r.action === 'Removed' ? 'is-removed' : 'is-edited'">{{ r.action }}</span></td>
                        <td data-label="Item">{{ r.itemName }}</td>
                        <td data-label="Changes"><div class="m-cell-col">
                          <div v-if="r.action === 'Removed'">Item removed</div>
                          <template v-else>
                            <div v-if="r.before.quantity !== r.after.quantity">Qty: {{ r.before.quantity }} → {{ r.after.quantity }}</div>
                            <div v-if="Math.abs(r.before.netWeight - r.after.netWeight) > 0.0005">Net Wt: {{ r.before.netWeight.toFixed(3) }} → {{ r.after.netWeight.toFixed(3) }} gm</div>
                            <div v-if="r.before.valueAddition !== r.after.valueAddition">VA: {{ r.before.valueAddition }}% → {{ r.after.valueAddition }}%</div>
                            <div v-if="r.before.discountAmount !== r.after.discountAmount">Discount: ₹ {{ r.before.discountAmount.toFixed(2) }} → ₹ {{ r.after.discountAmount.toFixed(2) }}</div>
                          </template>
                        </div></td>
                        <td data-label="Item Total (₹)" class="text-right text-no-wrap"><div class="m-cell-col">
                          <div class="revision-old">{{ r.before.itemTotal.toFixed(2) }}</div>
                          <div class="font-weight-bold">{{ r.after.itemTotal.toFixed(2) }}</div>
                        </div></td>
                        <td data-label="Bill Total (₹)" class="text-right text-no-wrap"><div class="m-cell-col">
                          <div class="revision-old">{{ r.billTotalBefore.toFixed(2) }}</div>
                          <div class="font-weight-bold">{{ r.billTotalAfter.toFixed(2) }}</div>
                        </div></td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>

              <!-- Old Gold Items Table -->
              <div v-if="previewList3 && previewList3.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-swap-horizontal</v-icon>
                  Old Metal Exchange Items ({{ previewList3.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table m-stack-grid">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-center">Metal</th>
                          <th class="text-right">Rate (₹)</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Melt (%)</th>
                          <th class="text-right">{{ billMode === 'Sale' ? 'Deduction Amt (₹)' : 'Payable Amt (₹)' }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList3" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">{{ value.itemName || '-' }}</td>
                          <td data-label="Metal" class="text-center">{{ value.metalType || 'Gold' }}</td>
                          <td data-label="Rate (₹)" class="text-right">{{ value.goldRate || '-' }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Melt (%)" class="text-right">{{ value.melt || 0 }}%</td>
                          <td data-label="Amount (₹)" class="text-right font-weight-bold text-success">{{ billMode === 'Sale' ? '- ' : '' }}₹ {{ value.itemAmount ? value.itemAmount.toFixed(2) : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>

              <!-- Return Items Table -->
              <div v-if="previewList5 && previewList5.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-keyboard-return</v-icon>
                  Return Items ({{ previewList5.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-right">Qty</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Return Amt (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList5" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">
                            <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="Qty" class="text-right">{{ value.quantity || '-' }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Return Amt (₹)" class="text-right font-weight-bold text-success">- ₹ {{ value.itemTotalAmount ? value.itemTotalAmount.toFixed(2) : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>

              <!-- Calculation Summary Block & Actions -->
              <div class="d-flex justify-space-between align-center flex-wrap mt-6 pt-4 border-t">
                <v-card outlined class="pa-4 preview-total-card mb-3 mb-md-0 preview-total-wrap">
                  <div class="d-flex justify-space-between py-1" v-if="previewList2.totalAmountWithGst">
                    <span class="summary-label">Bill Items Total:</span>
                    <span class="summary-value">₹ {{ (previewList2.totalAmountWithGst).toFixed(2) }}</span>
                  </div>
                  <div class="d-flex justify-space-between py-1" v-if="previewList2.oldGoldAmount">
                    <span class="summary-label text-success">{{ billMode === 'Sale' ? 'Old Gold Deduction:' : 'Old Gold/Silver Payable:' }}</span>
                    <span class="summary-value text-success">{{ billMode === 'Sale' ? '- ' : '' }}₹ {{ (previewList2.oldGoldAmount).toFixed(2) }}</span>
                  </div>
                  <div class="d-flex justify-space-between py-1" v-if="returnTotalAmt">
                    <span class="summary-label text-success">{{ billMode === 'Sale' ? 'Return Deduction:' : 'Return Payable:' }}</span>
                    <span class="summary-value text-success">{{ billMode === 'Sale' ? '- ' : '' }}₹ {{ (returnTotalAmt).toFixed(2) }}</span>
                  </div>
                  <div
                    class="d-flex justify-space-between py-1"
                    v-for="alloc in schemePreview"
                    :key="alloc.id"
                  >
                    <span class="summary-label text-success">Gold Scheme {{ alloc.schemeNumber }}:</span>
                    <span class="summary-value text-success">- ₹ {{ alloc.amount.toFixed(2) }}</span>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="revision-note mb-2" v-if="previewSaving > 0">
                    <v-icon x-small color="#15803d" class="mr-1">mdi-tag-arrow-down-outline</v-icon>
                    Revised from ₹ {{ Number(previewBaseline).toFixed(2) }} — customer saves ₹ {{ previewSaving.toFixed(2) }}
                  </div>
                  <div class="d-flex justify-space-between py-1 align-center" v-if="newTotal">
                    <span class="net-total-label">{{ billMode === 'Sale' ? 'Net Payable Amount:' : 'Amount Payable to Customer:' }}</span>
                    <span class="net-total-value">₹ {{ billMode === 'Sale' ? newTotal : Math.abs(newTotal) }}</span>
                  </div>
                </v-card>

                <div class="d-flex align-center preview-actions">
                  <v-btn outlined color="#64748b" class="mr-3 text-capitalize px-4" @click="preview = false">
                    Close Preview
                  </v-btn>
                  <v-btn outlined color="#475569" class="mr-3 text-capitalize px-4" :loading="previewDownloading" :disabled="!previewList2 || !previewList2._id" @click="downloadPreviewInvoice()">
                    <v-icon left small>mdi-download</v-icon>
                    Download Invoice
                  </v-btn>
                  <v-btn dark class="erp-action-btn text-capitalize px-6" @click="saveBill()">
                    <v-icon left>mdi-credit-card-check-outline</v-icon>
                    Proceed to Payment
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>

        <!-- Preview: Edit Item Dialog (revise price before payment) -->
        <v-dialog v-model="previewEditDialog" width="640px" persistent style="z-index: 3100;">
          <v-card class="rounded-lg erp-modal-card" v-if="previewEdit && previewEdit._id">
            <div class="modal-top-bar px-5 py-4 d-flex align-center justify-space-between">
              <div>
                <div class="modal-title">Revise Item</div>
                <div class="modal-subtext">
                  {{ previewEdit.designName }} — reduce quantity / weight, VA or add a discount
                </div>
              </div>
              <v-btn icon small @click="previewEditDialog = false">
                <v-icon color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <div class="pa-5">
              <v-row dense>
                <v-col cols="12" sm="4" class="py-1" v-if="previewEdit.isCount">
                  <label class="erp-field-label">Quantity (max {{ previewEdit.maxQuantity }})</label>
                  <v-text-field
                    v-model="previewEdit.quantity"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                    class="erp-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-1">
                  <label class="erp-field-label">
                    Net Wt (gm){{ previewEdit.isCount ? '' : ' (max ' + previewEdit.maxNetWeight + ')' }}
                  </label>
                  <v-text-field
                    v-if="!previewEdit.isCount"
                    v-model="previewEdit.netWeight"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                    class="erp-field"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="previewEditTotals.netWeight.toFixed(3)"
                    disabled
                    outlined
                    dense
                    hide-details
                    class="erp-field erp-readonly"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-1">
                  <label class="erp-field-label">Rate (₹/gm)</label>
                  <v-text-field
                    :value="previewEdit.goldRate"
                    disabled
                    outlined
                    dense
                    hide-details
                    class="erp-field erp-readonly"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-1" v-if="!previewEdit.isFlat">
                  <label class="erp-field-label">VA (%)</label>
                  <v-text-field
                    v-model="previewEdit.valueAddition"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                    class="erp-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-1">
                  <label class="erp-field-label">Making Charge (₹)</label>
                  <v-text-field
                    v-if="previewEdit.isFlat"
                    v-model="previewEdit.makingCharge"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                    class="erp-field"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="previewEditTotals.makingCharge.toFixed(2)"
                    disabled
                    outlined
                    dense
                    hide-details
                    class="erp-field erp-readonly"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-1">
                  <label class="erp-field-label">Discount (₹)</label>
                  <v-text-field
                    v-model="previewEdit.discountAmount"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                    class="erp-field"
                  ></v-text-field>
                </v-col>
              </v-row>

              <div class="revise-summary mt-4">
                <div class="d-flex justify-space-between py-1">
                  <span>Metal value</span>
                  <span>₹ {{ previewEditTotals.metalValue.toFixed(2) }}</span>
                </div>
                <div class="d-flex justify-space-between py-1">
                  <span>Making charge</span>
                  <span>₹ {{ previewEditTotals.makingCharge.toFixed(2) }}</span>
                </div>
                <div class="d-flex justify-space-between py-1" v-if="previewEditTotals.discount > 0">
                  <span>Discount</span>
                  <span>- ₹ {{ previewEditTotals.discount.toFixed(2) }}</span>
                </div>
                <div class="d-flex justify-space-between py-1" v-if="previewEditTotals.gst > 0">
                  <span>GST ({{ previewEdit.gstPercent }}%)</span>
                  <span>₹ {{ previewEditTotals.gst.toFixed(2) }}</span>
                </div>
                <v-divider class="my-2"></v-divider>
                <div class="d-flex justify-space-between py-1 font-weight-bold">
                  <span>Current item total</span>
                  <span>₹ {{ previewEdit.currentTotal.toFixed(2) }}</span>
                </div>
                <div class="d-flex justify-space-between py-1 font-weight-bold revise-new-total">
                  <span>Revised item total</span>
                  <span>₹ {{ previewEditTotals.total.toFixed(2) }}</span>
                </div>
                <div
                  class="text-right revise-diff"
                  :class="previewEditIsLower ? 'is-lower' : 'is-higher'"
                  v-if="Math.abs(previewEdit.currentTotal - previewEditTotals.total) >= 0.01"
                >
                  {{ previewEditIsLower ? 'Lower by' : 'Higher by' }}
                  ₹ {{ Math.abs(previewEdit.currentTotal - previewEditTotals.total).toFixed(2) }}
                </div>
              </div>
            </div>
            <v-divider></v-divider>
            <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
              <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="previewEditDialog = false">Cancel</v-btn>
              <v-btn dark class="erp-action-btn text-capitalize px-5" :loading="previewEditBusy" @click="savePreviewEdit()">
                <v-icon left small>mdi-check</v-icon>
                Update Estimate
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- Preview: Remove Item Confirmation -->
        <v-dialog v-model="previewDeleteDialog" width="420px" style="z-index: 3100;">
          <v-card class="rounded-lg erp-modal-card">
            <div class="modal-top-bar px-5 py-4 d-flex align-center">
              <v-icon color="#dc2626" class="mr-2">mdi-alert-circle-outline</v-icon>
              <span class="modal-title">Remove Item</span>
            </div>
            <v-divider></v-divider>
            <div class="pa-5" style="color: #334155; font-size: 14px;">
              Remove this item from the estimate? It goes back to stock and the totals are recalculated.
            </div>
            <v-divider></v-divider>
            <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
              <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="previewDeleteDialog = false">Cancel</v-btn>
              <v-btn color="#dc2626" dark class="text-capitalize px-4 rounded-lg" :loading="previewEditBusy" @click="removePreviewItem()">
                <v-icon left small>mdi-delete</v-icon>
                Remove Item
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- Boarding Rate Query Popup -->
        <v-dialog
          v-model="queryPopUpDialog"
          persistent
          :width="
            $vuetify.breakpoint.name == 'xs'
              ? '100vw'
              : $vuetify.breakpoint.name == 'sm'
              ? '60vw'
              : $vuetify.breakpoint.name == 'md'
              ? '50vw'
              : $vuetify.breakpoint.name == 'lg'
              ? '40vw'
              : '30vw'
          "
          style="z-index: 1000"
        >
          <v-card class="rounded-lg erp-modal-card">
            <div class="modal-top-bar px-6 py-4 d-flex align-center justify-space-between">
              <div>
                <div class="modal-title">Boarding Rate Update</div>
                <div class="modal-subtext">Set current market boarding rates per gram</div>
              </div>
              <v-btn icon small @click="queryPopUpDialog = false">
                <v-icon small color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-layout wrap pa-4>
              <v-flex xs12 sm6 pa-2>
                <v-card outlined class="pa-3 text-center">
                  <div class="erp-field-label text-center mb-1">THANKAM Per gm</div>
                  <v-text-field
                    autofocus
                    placeholder="0"
                    prefix="₹"
                    v-model="thankamRate"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-card outlined class="pa-3 text-center">
                  <div class="erp-field-label text-center mb-1">GOLD Per gm</div>
                  <v-text-field
                    prefix="₹"
                    v-model="gold"
                    type="number"
                    placeholder="0"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-card outlined class="pa-3 text-center">
                  <div class="erp-field-label text-center mb-1">SILVER Per gm</div>
                  <v-text-field
                    v-model="silverRate"
                    type="number"
                    prefix="₹"
                    placeholder="0"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-card outlined class="pa-3 text-center">
                  <div class="erp-field-label text-center mb-1">PLATINUM Per gm</div>
                  <v-text-field
                    prefix="₹"
                    v-model="platinumRate"
                    type="number"
                    placeholder="0"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-card outlined class="pa-3 text-center">
                  <div class="erp-field-label text-center mb-1">DIAMOND</div>
                  <v-text-field
                    prefix="₹"
                    v-model="diamond"
                    type="number"
                    placeholder="0"
                    outlined
                    dense
                    color="#9a6b27"
                    hide-details
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 pa-2 align-self-end>
                <v-btn
                  height="45px"
                  dark
                  class="erp-action-btn font-weight-bold"
                  block
                  @click="EditRate()"
                >
                  <v-icon left small>mdi-check</v-icon>
                  Save Rates
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ESaddItem from "./ESaddItem";
import oldGold from "./oldGold";
import returnGold from "./returnGold";

export default {
  components: {
    ESaddItem,
    oldGold,
    returnGold,
  },
  data() {
    return {
      dialog:false,
      //bordingrate
      gold: "",
      thankamRate: "",
      silverRate: "",
      platinumRate: "",
      diamond: "",
      queryPopUpDialog: false,
      //
      billMode: "Sale",
      billModeOptions: ["Sale", "Old Gold / Silver Purchase", "Sales Return"],
      quotation: "1",
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      estno: null,
      billPrefix: null,
      salesmanOptions: [],
      value: "",
      newCustomer: null,
      newAddress: null,
      newCity: null,
      newContact: null,
      newpinNumber: null,
      newCustomerPAN: null,
      newCustomerAadhar: null,
      addcustomerdialogue: false,
      addcat: false,
      // bill:null,
      customerName: null,
      address: null,
      city: null,
      contact: null,
      salesmenCode: localStorage.getItem("staffCode"),
      billData: {},
      itemz: [],
      datareload: false,
      addcat2: false,
      purity: null,
      oldstoneweight: null,
      oldstoneprice: null,
      oldlessweight1: null,
      oldlessweight2: null,
      oldgrossweight: null,
      oldnetweight: null,
      oldprice: null,
      oldtotal: null,
      tax: null,
      saleweight: null,
      saleamount: null,
      oldfinalTotal: null,
      returnbillno: null,
      returndate: null,
      juwellaryId: localStorage.getItem("juwellaryId"),
      returnsalesId: null,
      returndata: [],
      olditems: [],
      categoryList: [],
      itempresent: false,
      returnbillNo: null,
      returncustomerName: null,
      returnmobileNumber: null,
      returnstaffCode: null,
      returnTotalAmt: 0,
      returnNetWt: 0,
      customerList: [],
      returngoldRate: "",
      cid: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      panRules: [
  (value) => !!value || "PAN number is required.",
  (value) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) || "Invalid PAN number.",
],
pinRules: [
    (value) => !!value || "PIN number is required.",
    (value) => /^\d{6}$/.test(value) || "Invalid PIN number.",
  ],
aadhaarRules: [
  (value) => !!value || "Aadhaar number is required.",
  (value) => /^\d{12}$/.test(value) || "Invalid Aadhaar number.",
],
      //preview
      preview: false,
      previewList1:[],
      previewList2:[],
      previewList3:[],
      previewList4:[],
      previewList5:[],
      saleTTL:"",
      newTotal:"",
      //revising the estimate from the preview
      previewEdit: {},
      previewEditDialog: false,
      previewDownloading: false,
      previewDeleteDialog: false,
      previewDeleteId: null,
      previewEditBusy: false,
      previewBaseline: null,
      //gold scheme
      redeemableSchemes: [],
      selectedSchemeIds: [],
      schemePreview: [],
      grate:"",
    };
  },
  beforeMount() {
    this.getCustomer();
    this.getBill();
    this.userinfo();
    this.getSalesmanList();
  },
  watch: {
    billData() {
      this.customerName = this.billData.customerId;
      this.address = this.billData.customerId.address;
      this.city = this.billData.customerId.city;
      this.contact = this.billData.customerId.mobileNumber;
      this.selectedSchemeIds = (this.billData.goldSchemeSelections || []).map((x) => (x && x._id) || x);
      this.getRedeemableSchemes();
    },
    cid() {
      console.log("cid==", this.cid);
      this.customerName = this.cid;
      this.customerdetails();
    },
  },
  computed: {
    taxType() {
      return localStorage.getItem("GSTstatus");
    },
    canEditPreview() {
      return this.billMode === "Sale";
    },
    revisionHistory() {
      var h = (this.previewList2 && this.previewList2.revisionHistory) || [];
      return h.slice().reverse();
    },
    previewSaving() {
      if (this.previewBaseline == null || this.newTotal === "") return 0;
      var diff = parseFloat(this.previewBaseline) - parseFloat(this.newTotal);
      return diff >= 0.01 ? diff : 0;
    },
    // Live price of the item being revised; mirrors /sales/edit on the server
    previewEditTotals() {
      var e = this.previewEdit || {};
      var rate = parseFloat(e.goldRate) || 0;
      var netWeight = e.isCount
        ? ((parseFloat(e.itemPerWeight) || 0) - (e.stonePerPiece || 0)) * (parseFloat(e.quantity) || 0)
        : parseFloat(e.netWeight) || 0;
      var metalValue = rate * netWeight;
      var makingCharge = e.isFlat
        ? parseFloat(e.makingCharge) || 0
        : metalValue * ((parseFloat(e.valueAddition) || 0) / 100);
      var discount = parseFloat(e.discountAmount) || 0;
      var taxable = metalValue + makingCharge - discount;
      var gst = this.taxType == "true" ? taxable * ((e.gstPercent || 0) / 100) : 0;
      return { netWeight, metalValue, makingCharge, discount, gst, total: taxable + gst };
    },
    previewEditIsLower() {
      return this.previewEditTotals.total <= (this.previewEdit.currentTotal || 0);
    },
    schemeAvailableTotal() {
      return this.redeemableSchemes.reduce((sum, x) => sum + (x.availableAmount || 0), 0);
    },
  },
  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    userinfo() {
      axios({
        method: "GET",
        url: "/user/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: localStorage.getItem("id"),
        },
      })
        .then((response) => {
          // console.log("menu-loginpage");
          if (response.data.status) {
            var check = response.data.goldrateadded;
            if (check == false) {
              console.log("check===-=", check);
              this.queryPopUpDialog = true;
            }
          } else {
            console.log("estpage user info");
            return;
          }
        })
        .catch((err) => {
          var msg = err;
          console.log(msg);
        });
    },
    winStepper(item) {
      if (item.ref == "addedItem") {
        console.log("item==", item.items1);
        if (item.check == true || item.items1) {
          this.itemz = item.items1;
          this.grate=item.grate;
          console.log("grate=",this.grate)
          this.addItem();
        }
      }
      if (item.ref == "customerData") {
        if (item.saledata) {
          this.billData = item.saledata;

          console.log("billData1==", this.billData);
        }
      }
      if (item.ref == "returnItems") {
        if (item.returndata || item.returnsalesId) {
          this.returngoldRate = item.returngoldRate;
          console.log("returngoldRate==", item.returngoldRate);
          this.returnTotalAmt = item.returnTotalAmt;
          console.log("returnTotalAmt==", item.returnTotalAmt);
          this.returnNetWt = item.returnNetWt;
          console.log("returnNetWt==", item.returnNetWt);
          this.returndata = item.returndata;
          console.log("returndata==", item.returndata);
          this.returnsalesId = item.returnsalesId;
          console.log("returnsalesId==", item.returnsalesId);
          this.returnbillNo = item.billNo;
          this.returncustomerName = item.customerName;
          this.returnmobileNumber = item.mobileNumber;
          this.returnstaffCode = item.staffCode;
        }
      }
      if (item.ref == "itempresent") {
        if (item.itempresent) {
          this.itempresent = item.itempresent;
          console.log("itempresent==", item.itempresent);
        }
      }
    },
    validate() {
      if (!this.customerName) {
        this.msg = "Please enter customer name ";
        this.showsnackbar = true;
      } else if (!this.contact) {
        this.msg = "Please enter contact number ";
        this.showsnackbar = true;
      } else {
        // this.saveBill();
        this.previewBaseline = null;
        this.getpreviewbill();
        this.preview = true;
      }
    },
    calctotal(){
this.newTotal=0;
this.saleTTL=0;
console.log("tax==",this.taxType)
if(this.taxType=='true')
{
  this.saleTTL = this.previewList2.totalAmountWithGst || 0
  console.log("this.previewList2.totalAmountWithGst=",this.saleTTL)
}
else{
  this.saleTTL = this.previewList2.totalAmountWithoutGst || 0
  console.log("this.previewList2.totalAmountWithoutGst=",this.saleTTL)
}
if(this.previewList2.oldGoldAmount){
  this.saleTTL= this.saleTTL-this.previewList2.oldGoldAmount;
  console.log("this.previewList2.oldGoldAmount=",this.saleTTL)
}
if(this.returnTotalAmt){
  this.saleTTL= this.saleTTL-this.returnTotalAmt;
  console.log("this.previewList2.returnTotalAmt=",this.saleTTL)
}
//preview of the selected schemes, used in the order picked; the settlement
//screen recomputes this after any discount/advance and the server redeems it
this.schemePreview=[];
var schemeRemaining = Math.max(0, this.saleTTL);
if(this.billMode === 'Sale'){
  this.selectedSchemeIds.forEach((id) => {
    var scheme = this.redeemableSchemes.find((x) => x._id === id);
    if (!scheme || schemeRemaining <= 0) return;
    var take = Math.round(Math.min(scheme.availableAmount, schemeRemaining) * 100) / 100;
    if (take <= 0) return;
    this.schemePreview.push({ id: id, schemeNumber: scheme.schemeNumber || '', amount: take });
    schemeRemaining = Math.round((schemeRemaining - take) * 100) / 100;
    this.saleTTL = this.saleTTL - take;
  });
}
var ttl = this.saleTTL.toFixed(2);
this.newTotal=ttl;
    },
    getSalesmanList() {
      axios({
        method: "get",
        url: "/staff/salesmanlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.salesmanOptions = response.data.data.map((staff) => ({
              staffCode: staff.staffCode,
              label: staff.firstname + " " + (staff.lastname || "") + " (" + staff.staffCode + ")",
            }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    startPurchaseOrReturn() {
      if (!this.customerName || !this.contact) {
        this.msg = "Please select a customer first";
        this.showsnackbar = true;
        return;
      }
      this.appLoading = true;
      axios({
        url: "/sales/add",
        method: "POST",
        data: {
          goldRate: localStorage.getItem("goldRate"),
          items: [],
          isEdit: false,
          customerId: this.customerName,
          address: this.address,
          city: this.city,
          mobileNumber: this.contact,
          date: this.date,
          billNo: this.estno,
          billPrefix: this.billPrefix,
          staffCode: this.salesmenCode,
          jewelleryId: this.juwellaryId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.fetchBareSale();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    fetchBareSale() {
      axios({
        url: "/sales/getlist",
        method: "get",
        params: {
          billNo: this.estno,
          status: "Pending",
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true && response.data.saledata) {
            this.billData = response.data.saledata;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getBill() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sales/bill/generate",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // this.Details = response.data;
            this.estno = response.data.bill;
            console.log("estno=", this.estno);
            this.datareload = true;
            // this.getData();
            // this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addItem() {
      this.datareload = false;
      axios({
        url: "/sales/add",
        method: "POST",
        data: {
          goldRate:this.grate,
          items: this.itemz,
          isEdit:false,
          customerId: this.customerName,
          address: this.address,
          city: this.city,
          mobileNumber: this.contact,
          date: this.date,
          billNo: this.estno,
          billPrefix: this.billPrefix,
          staffCode: this.salesmenCode,
          jewelleryId: this.juwellaryId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            console.log("if")

            this.datareload = true;

            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.email = null;
            this.phone = null;
            this.name = null;
            this.address = null;
            this.username = null;
            this.datareload = true;
          } if (response.data.status == false && response.data.isExist == true) {
            console.log("elseif-bill exists")
            this.msg = "Bill used by another user";
            this.showsnackbar = true;
            // this.getBill();
            setTimeout(() => {location.reload();}, "2000");
            

           }
            else {
            console.log("else")
            this.datareload = true;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    saveBill() {
      this.datareload = false;
      axios({
        url: "/sales/generate",
        method: "POST",
        data: {
          customerId:this.customerName,
          goldSchemeIds: this.billMode === 'Sale' ? this.selectedSchemeIds : [],
          returngoldRate: this.returngoldRate,
          saleId: this.billData._id,
          returnSaleId: this.returnsalesId,
          currentReturnItems: this.returndata,
          billNo: this.returnbillNo,
          // customerName: this.returncustomerName,
          staffCode: this.returnstaffCode,
          jewelleryId: this.juwellaryId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.datareload = true;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.email = null;
            this.phone = null;
            this.name = null;
            this.address = null;
            this.username = null;
            // this.printBill();
            // this.$router.push('/SalesSettlement?no='+this.billData._id)
            this.$router.push("/SalesList");
          } else {
            this.datareload = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCustomer(keyword) {
      axios({
        method: "get",
        url: "/customer/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: keyword ? { keyword: keyword } : {},
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.customerList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    searchCustomerByKeyword(keyword) {
      clearTimeout(this._customerSearchTimeout);
      this._customerSearchTimeout = setTimeout(() => {
        this.getCustomer(keyword);
      }, 300);
    },
    customerFilter(item, queryText) {
      var text = queryText ? queryText.toLowerCase() : "";
      var name = (item.customerName || "").toLowerCase();
      var phone = (item.mobileNumber || "").toLowerCase();
      return name.includes(text) || phone.includes(text);
    },
    // printBill() {
    //   axios({
    //     method: "get",
    //     url: "/download/invoice",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     params: {
    //   id:this.billData._id,

    //     },

    //   })
    //     .then((response) => {
    //       // this.appLoading = false;
    //       if (response.data.status == true) {

    //       } else {
    //         this.snackbar = true;
    //         this.msg = response.data.msg;
    //       }

    //       // this.msg = response.data.msg;

    //       // this.snackbar = true;
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       console.log(err);
    //     });
    // },
    customerIdValue() {
      var c = this.customerName;
      return c && typeof c === "object" ? c._id : c;
    },
    getRedeemableSchemes() {
      var customerId = this.customerIdValue();
      if (!customerId) {
        this.redeemableSchemes = [];
        this.selectedSchemeIds = [];
        return;
      }
      axios({
        method: "get",
        url: "/goldscheme/customer/redeemable",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          customerId: customerId,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.redeemableSchemes = response.data.data || [];
            var ids = this.redeemableSchemes.map((x) => x._id);
            this.selectedSchemeIds = this.selectedSchemeIds.filter((id) => ids.includes(id));
          } else {
            this.redeemableSchemes = [];
            this.selectedSchemeIds = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleScheme(id) {
      if (this.selectedSchemeIds.includes(id)) {
        this.selectedSchemeIds = this.selectedSchemeIds.filter((x) => x !== id);
      } else {
        this.selectedSchemeIds = this.selectedSchemeIds.concat([id]);
      }
    },
    formatAmount(n) {
      return Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    customerdetails() {
      axios({
        method: "get",
        url: "/customer/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.customerName,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            // this.customerName = response.data.data;
            this.address = response.data.data.address;
            this.city = response.data.data.city;
            this.contact = response.data.data.mobileNumber;
            this.selectedSchemeIds = [];
            this.getRedeemableSchemes();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;

            // if (this.snackbar == false) {
            //   this.$router.go();
            // }

            // setTimeout(() => this.$router.go(),3000)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AddCustomer() {
      axios({
        url: "/customer/add",
        method: "POST",
        data: {
          customerName: this.newCustomer,
          address: this.newAddress,
          city: this.newCity,
          mobileNumber: this.newContact,
      pinNumber: this.newpinNumber,
          jewelleryId: this.juwellaryId,
          panNo: this.newCustomerPAN,
          aadharNo: this.newCustomerAadhar,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.addcustomerdialogue = false;
            this.getCustomer();
            this.cid = response.data.customerData._id;
            // customerdetails
            // this.customerName=this.newCustomer;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.newCustomer = null;
            this.newAddress = null;
            this.newCity = null;
            this.newContact = null;
            this.newpinNumber = null;
            this.newCustomerPAN = null;
            this.newCustomerAadhar = null;
            this.$refs.addcat.resetValidation();
          } else {
            this.datareload = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    EditRate() {
      axios({
        url: "/rate/add",
        method: "POST",
        data: {
          goldRate: this.gold,
          silverRate: this.silverRate,
          platinumRate: this.platinumRate,
          diamond: this.diamond,
          date: this.date,
          thankamRate: this.thankamRate,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.queryPopUpDialog = false;
            localStorage.setItem("diamond", response.data.data.diamond);
            localStorage.setItem("goldRate", response.data.data.goldRate);
            localStorage.setItem(
              "platinumRate",
              response.data.data.platinumRate
            );
            localStorage.setItem("silverRate", response.data.data.silverRate);
            localStorage.setItem("thankamRate", response.data.data.thankamRate);
            location.reload();

            // this.goldrate = null;
            // this.silverrate = null;
            // this.platinumrate = null;
            // this.diamondrate = null;
            this.date = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    //for preview
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      //  +
      // " , " +
      // hours +
      // ":" +
      // minutes +
      // " " +
      // ampm;

      return strTime;
    },
    formatRevisionDate(d) {
      return d ? new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
    },
    openPreviewEdit(value) {
      var countOrSplit = (value.purchaseItemId && value.purchaseItemId.countOrSplit) || (value.designId && value.designId.countOrSplit);
      var isCount = countOrSplit == "Count" && value.quantity > 0;
      var stock = value.purchaseItemId || {};
      var isFlat = value.metalType === "Silver" && value.makingChargeType === "Flat";
      this.previewEdit = {
        _id: value._id,
        designName: value.designId ? value.designId.name + " - " + (value.itemId ? value.itemId.name : "") : "Item",
        isCount: isCount,
        isFlat: isFlat,
        quantity: value.quantity,
        netWeight: value.netWeight,
        itemPerWeight: value.itemPerWeight,
        stonePerPiece: value.quantity > 0 ? (value.stoneWeight || 0) / value.quantity : 0,
        // this line already holds its own stock, so it can go up to remaining + held
        maxQuantity: (stock.count || 0) + (value.quantity || 0),
        maxNetWeight: Number(((stock.netWeight || 0) + (value.netWeight || 0)).toFixed(3)),
        goldRate: value.goldRate,
        valueAddition: value.valueAddition,
        makingCharge: value.makingCharge,
        discountAmount: value.discountAmount || 0,
        metalType: value.metalType,
        makingChargeType: value.makingChargeType,
        gstPercent: (value.cgst || 0) + (value.sgst || 0),
        currentTotal: this.taxType == "true" ? value.amountWithGst || 0 : value.amountWithoutGst || 0,
      };
      this.previewEditDialog = true;
    },
    savePreviewEdit() {
      var e = this.previewEdit;
      var t = this.previewEditTotals;
      var qty = parseFloat(e.quantity) || 0;
      if (e.isCount && (qty < 1 || qty > e.maxQuantity || qty % 1 !== 0)) {
        this.msg = "Quantity must be a whole number between 1 and " + e.maxQuantity;
        this.showsnackbar = true;
        return;
      }
      if (t.netWeight <= 0 || (!e.isCount && t.netWeight > e.maxNetWeight)) {
        this.msg = "Net weight must be between 0 and " + e.maxNetWeight + " gm";
        this.showsnackbar = true;
        return;
      }
      if ((parseFloat(e.valueAddition) || 0) < 0 || t.makingCharge < 0 || t.discount < 0) {
        this.msg = "Values cannot be negative";
        this.showsnackbar = true;
        return;
      }
      if (t.discount > 0 && t.discount >= t.makingCharge) {
        this.msg = "Discount must be less than the making charge (₹ " + t.makingCharge.toFixed(2) + ")";
        this.showsnackbar = true;
        return;
      }
      this.previewEditBusy = true;
      axios({
        url: "/sales/edit",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: e._id,
          items: [
            {
              quantity: e.isCount ? qty : 0,
              netWeight: t.netWeight,
              goldRate: e.goldRate,
              valueAddition: e.isFlat ? e.valueAddition : parseFloat(e.valueAddition) || 0,
              makingCharge: t.makingCharge,
              discountAmount: t.discount,
              metalType: e.metalType,
              makingChargeType: e.makingChargeType,
            },
          ],
        },
      })
        .then((response) => {
          this.previewEditBusy = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.previewEditDialog = false;
            this.afterPreviewChange();
          }
        })
        .catch((err) => {
          this.previewEditBusy = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removePreviewItem() {
      this.previewEditBusy = true;
      axios({
        url: "/saleitem/delete",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.previewDeleteId,
        },
      })
        .then((response) => {
          this.previewEditBusy = false;
          this.previewDeleteDialog = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            if (this.previewList1.length <= 1) {
              // nothing left to quote - back to the estimate to add items
              this.preview = false;
            }
            this.afterPreviewChange();
          }
        })
        .catch((err) => {
          this.previewEditBusy = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    afterPreviewChange() {
      // refresh the preview totals and the item list on the estimate page behind it
      this.getpreviewbill();
      this.datareload = false;
      this.$nextTick(() => {
        this.datareload = true;
      });
    },
    downloadPreviewInvoice() {
      if (!this.previewList2 || !this.previewList2._id) return;
      this.previewDownloading = true;
      axios({
        method: "get",
        url: "/download/invoice",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { id: this.previewList2._id, preview: true },
        responseType: "blob",
      })
        .then((response) => {
          this.previewDownloading = false;
          if (response.data.type && response.data.type.indexOf("application/pdf") === -1) {
            this.msg = "Failed to download invoice";
            this.showsnackbar = true;
            return;
          }
          const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Estimate_${this.previewList2.billPrefix || ""}${this.previewList2.billNo || "bill"}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.previewDownloading = false;
          this.msg = "Failed to download invoice";
          this.showsnackbar = true;
        });
    },
    getpreviewbill() {
      axios({
        url: "/sales/getlist",
        method: "get",
        params: {
          billNo: this.estno,
          status: "Pending",
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.previewList1 = response.data.data;
            this.previewList2 = {
              ...response.data.saledata,
              customerName: (response.data.saledata && response.data.saledata.customerName) || this.returncustomerName,
              mobileNumber: (response.data.saledata && response.data.saledata.mobileNumber) || this.returnmobileNumber,
              staffCode: (response.data.saledata && response.data.saledata.staffCode) || this.returnstaffCode,
            };
            this.calctotal();
            if (this.previewBaseline == null) {
              this.previewBaseline = this.newTotal;
            }
          } else {
            this.msg = response.data.msg;
            // this.showsnackbar = true;
          }
        this.getpreviewOldgold();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getpreviewOldgold() {
      axios({
        url: "/oldgolditem/getlist",
        method: "get",
        params: {
          salesId: this.billData._id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.previewList3 = response.data.data;
            this.previewList4 = response.data.bill;
          }
        // this.getpreviewReturns();
        this.previewList5 = this.returndata;

        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.preview-edit-hint {
  font-size: 12px;
  color: #64748b;
}
.revision-history {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
}
.revision-table th {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #475569 !important;
  background: #f8fafc;
  text-transform: uppercase;
}
.revision-table td {
  font-size: 12.5px !important;
  color: #334155;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.revision-old {
  color: #94a3b8;
  text-decoration: line-through;
}
.revision-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}
.revision-tag.is-edited {
  background: #fef3c7;
  color: #92400e;
}
.revision-tag.is-removed {
  background: #fee2e2;
  color: #b91c1c;
}
.revision-note {
  font-size: 12px;
  font-weight: 600;
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
  padding: 4px 8px;
}
.revise-summary {
  background: #faf7f0;
  border: 1px solid #eee2cc;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #334155;
}
.revise-new-total {
  color: #9a6b27;
}
.revise-diff {
  font-size: 12px;
  font-weight: 600;
}
.revise-diff.is-lower {
  color: #15803d;
}
.revise-diff.is-higher {
  color: #b91c1c;
}
.estimate-page-wrapper {
  color: #1e293b;
  max-width: 1440px;
  margin: 0 auto;
  padding: 12px 16px 80px 16px;
  width: 100%;
}

.estimate-header-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.estimate-title-tag {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #0f172a;
}

.estimate-prefix-field {
  width: 90px;
}

.estimate-prefix-field >>> .v-input__control {
  min-height: 36px !important;
}

.estimate-prefix-field >>> .v-input__slot {
  min-height: 36px !important;
  font-size: 13px;
  background-color: #f8fafc !important;
}

.estimate-number-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
}

.estimate-date-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #475569;
}

.header-divider {
  margin: 16px 0;
}

.header-controls-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 1fr));
  gap: 16px;
}

.header-control-col {
  display: flex;
  flex-direction: column;
}

.header-control-col .erp-field >>> .v-input__control {
  min-height: 40px !important;
}

.header-control-col .erp-field >>> .v-input__slot {
  min-height: 40px !important;
  font-size: 13.5px;
  background-color: #ffffff !important;
}

@media (max-width: 600px) {
  .header-controls-row {
    grid-template-columns: 1fr;
  }
}

.estimate-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.card-top-bar {
  background: #fafafa;
}

.card-heading {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #0f172a;
}

.erp-btn-secondary {
  border-color: #cbd5e1 !important;
  color: #334155 !important;
  font-weight: 600;
  font-size: 12px;
}

.customer-grid {
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(180px, 1fr);
  gap: 16px;
  align-items: flex-start;
}

.customer-field-col {
  display: flex;
  flex-direction: column;
}

.scheme-total-hint {
  font-size: 12.5px;
  font-weight: 700;
  color: #9a6b27;
}

.scheme-help {
  font-size: 12px;
  color: #64748b;
}

.scheme-row {
  padding: 6px 0;
  border-bottom: 1px dashed #e2e8f0;
  gap: 12px;
}

.scheme-row:last-child {
  border-bottom: none;
}

.scheme-no-pill {
  font-size: 11.5px;
  font-weight: 700;
  color: #9a6b27;
  background: #fdf6ec;
  border: 1px solid #f1dfc2;
  border-radius: 6px;
  padding: 1px 8px;
}

.scheme-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.scheme-status {
  font-size: 11px;
  color: #64748b;
}

.scheme-avail {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
}

.erp-field-label {
  display: block;
  font-size: 11.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 6px;
}

.erp-field >>> .v-input__slot {
  border-radius: 8px !important;
  font-size: 13.5px;
}

.erp-readonly >>> .v-input__slot {
  background-color: #f8fafc !important;
}

.required-star {
  color: #dc2626;
}

.generate-estimate-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.03em;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.generate-estimate-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

.erp-modal-card {
  background: #ffffff !important;
}

.modal-top-bar {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtext {
  font-size: 12px;
  color: #64748b;
}

.bg-modal-footer {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.erp-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 600;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.erp-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

/* Preview Modal */
.preview-page-card {
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
}

.preview-header {
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.preview-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.05em;
}

.preview-scroll-area {
  flex: 1;
  overflow-y: auto;
}

.preview-info-card {
  background: #ffffff !important;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.preview-info-heading {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 6px;
}

.preview-info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  padding: 6px 0;
  border-bottom: 1px solid #f8fafc;
}

.preview-info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 140px;
  min-width: 140px;
  flex-shrink: 0;
  color: #64748b;
  font-weight: 500;
}

.info-val {
  color: #0f172a;
  font-weight: 600;
  flex: 1;
  word-break: break-word;
}

.preview-table-title {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.preview-table thead {
  background-color: #f1f5f9;
}

.preview-table thead th {
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569 !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.preview-table tbody td {
  font-size: 12.5px !important;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9 !important;
}

.preview-total-card {
  background: #ffffff !important;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  min-width: 320px;
}

.summary-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.summary-value {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.net-total-label {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.net-total-value {
  font-size: 17px;
  font-weight: 800;
  color: #9a6b27;
}

.border-t {
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 900px) {
  .customer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .customer-grid {
    grid-template-columns: 1fr;
  }
}

/* ---- Phones ---- */
@media (max-width: 600px) {
  .scheme-row {
    flex-wrap: wrap;
  }
  .scheme-row .v-input {
    flex: 1 1 100%;
    min-width: 0;
  }
  .scheme-row >>> .v-label {
    flex-wrap: wrap;
    row-gap: 4px;
    height: auto;
  }
  .scheme-avail {
    margin-left: 32px;
  }
  .preview-head-bar {
    padding-left: 16px !important;
    padding-right: 8px !important;
  }
  .preview-title {
    font-size: 13px;
  }
  .preview-body {
    padding: 12px !important;
  }
  .revision-history {
    padding: 8px;
  }
  .preview-total-card.preview-total-wrap {
    width: 100%;
    min-width: 0 !important;
  }
  .preview-actions {
    flex-direction: column-reverse;
    align-items: stretch !important;
    width: 100%;
    gap: 8px;
  }
  .preview-actions .v-btn {
    width: 100%;
    margin-right: 0 !important;
  }
  .preview-info-row {
    flex-wrap: wrap;
    gap: 2px 8px;
  }
}
</style>